import { render, staticRenderFns } from "./doing_business_as.vue?vue&type=template&id=04a5b5ee&"
import script from "./doing_business_as.vue?vue&type=script&lang=js&"
export * from "./doing_business_as.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports